import type { Locale } from '../common/@types'
import { parseLanguage } from '../common/utils'
import cacheRequest from '../utils/cacheRequest'
import type { Messages } from './@types'
import { fetchLang } from './service'

class Intl {
  private messages: Messages
  constructor(messages: Messages) {
    this.messages = messages
  }

  get(key: keyof Messages) {
    return this.messages[key]
  }
}

const buildIntl = async (locale: Locale) => {
  const lang = parseLanguage(locale)
  const messages = await cacheRequest(fetchLang, [lang], 'fetchLang')
  return new Intl(messages)
}

export default buildIntl
